import { useEffect } from 'react';
import { useCrashReport } from '../../context/CrashReportProvider';

const CrashReportEventListener = () => {
  const { openCrashReport } = useCrashReport();

  useEffect(() => {
    const handleOpenCrashReport = (event) => {
      openCrashReport(event.detail);
    };

    window.addEventListener('openCrashReport', handleOpenCrashReport);

    return () => {
      window.removeEventListener('openCrashReport', handleOpenCrashReport);
    };
  }, [openCrashReport]);

  return null;
};

export default CrashReportEventListener;